/** iter 42 — Mobile / Job detail (view-only, with quick "+ Add Attempt"). */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../lib/api";
import MobileShell from "../MobileShell";

function Field({ label, value }) {
  if (value === null || value === undefined || value === "") return null;
  return (
    <div className="m-field">
      <div className="m-field-label">{label}</div>
      <div>{value}</div>
    </div>
  );
}

export default function MJobDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [err, setErr] = useState("");

  const load = () => {
    api.get(`/mobile/jobs/${id}`)
      .then(r => setJob(r.data))
      .catch(e => setErr(e?.response?.data?.detail || e.message));
  };
  useEffect(() => { load(); }, [id]);

  return (
    <MobileShell title={job ? `Job #${job.job_number || ""}` : "Job"} back="/m/jobs">
      {err && <div className="m-empty">{String(err)}</div>}
      {!err && !job && <div className="m-empty">Loading…</div>}
      {job && (
        <>
          <div className="m-card" data-testid="m-job-summary">
            <Field label="Job #" value={job.job_number} />
            <Field label="Customer" value={job.customer_name} />
            <Field label="Customer phone" value={job.customer_phone} />
            <Field label="Job type" value={job.job_type_name} />
            <Field label="Status" value={job.job_status_name || job.service_status} />
            <Field label="Service speed" value={job.service_speed} />
            <Field label="Due date" value={job.due_date} />
            <Field label="Received" value={job.received_at} />
            <Field label="Case #" value={job.case_number} />
            <Field label="Plaintiff" value={job.plaintiff} />
            <Field label="Defendant" value={job.defendant} />
            <Field label="Notes" value={job.notes} />
            <Field label="Special instructions" value={job.special_instructions} />
            <Field label="Account #" value={job.account_number} />
            <Field label="Billing ref" value={job.billing_ref} />
          </div>

          {job.locations?.length > 0 && (
            <div className="m-card" data-testid="m-job-locations">
              <div className="m-card-title">Service locations</div>
              {job.locations.map(l => (
                <div key={l.join_id || l.id} className="m-field" style={{ marginTop: 8 }}>
                  <div style={{ fontWeight: 600 }}>{l.name || `${l.address1 || ""}`}</div>
                  <div className="m-card-sub">
                    {[l.address1, l.address2, l.city, l.state, l.postal_code].filter(Boolean).join(", ")}
                  </div>
                  {l.phone && <div className="m-card-sub">Tel: {l.phone}</div>}
                  {l.type_of_dwelling && <div className="m-card-sub">Dwelling: {l.type_of_dwelling}</div>}
                  {l.additional_notes && <div className="m-card-sub">{l.additional_notes}</div>}
                </div>
              ))}
            </div>
          )}

          {job.subjects?.length > 0 && (
            <div className="m-card" data-testid="m-job-subjects">
              <div className="m-card-title">Subjects</div>
              {job.subjects.map(s => (
                <div key={s.id} className="m-field" style={{ marginTop: 6 }}>
                  <div style={{ fontWeight: 600 }}>
                    {[s.first_name, s.middle_name, s.last_name].filter(Boolean).join(" ") || s.aka || "Subject"}
                  </div>
                  {s.aka && <div className="m-card-sub">a.k.a. {s.aka}</div>}
                </div>
              ))}
            </div>
          )}

          <div className="m-card" data-testid="m-job-attempts">
            <div className="m-card-title">Service attempts ({job.attempts?.length || 0})</div>
            {job.attempts?.length === 0 && (
              <div className="m-card-sub">No attempts logged yet.</div>
            )}
            {job.attempts?.map(a => (
              <button
                key={a.id}
                type="button"
                className="m-card"
                style={{ width: "100%", textAlign: "left", margin: "8px 0 0", cursor: "pointer" }}
                onClick={() => navigate(`/m/attempts/${a.id}`)}
                data-testid={`m-attempt-row-${a.id}`}
              >
                <div style={{ fontWeight: 600 }}>{a.outcome || "Attempt"}</div>
                <div className="m-card-sub">{a.attempted_at}</div>
                {a.notes && <div className="m-card-sub">{a.notes}</div>}
              </button>
            ))}
          </div>

          <button
            type="button"
            className="m-btn m-btn-primary"
            onClick={() => navigate(`/m/jobs/${id}/attempt/new`)}
            data-testid="m-add-attempt-btn"
          >+ ADD ATTEMPT</button>
        </>
      )}
    </MobileShell>
  );
}
